// extracted by mini-css-extract-plugin
export var BaseNavigation = "base-navigation-module--BaseNavigation--mkLYE";